export const TIME_RESEND_CODE = '5:00';
